import icon from "../../assets/smartphone.svg";
import type { Property } from "../../types";

export const mobileTap: Property = {
  id: "mobileTap",
  title: "mobileTap.title",
  icon,
};
